import { Box, Typography } from "@mui/material";
import React from "react";
import theme from "Theme/AppTheme";

type Props = {
    messages: string[];
    /** Warnings come back alongside a successful save, so they are not an error state. */
    variant?: "error" | "warning";
};

const EmissionsFormErrorBanner: React.FC<Props> = ({
    messages,
    variant = "error",
}) => {
    if (!messages.length) return null;

    const isError = variant === "error";
    const palette = isError ? theme.palette.error : theme.palette.warning;

    return (
        <Box
            role={isError ? "alert" : "status"}
            sx={{
                backgroundColor: palette[50],
                border: `1px solid ${palette[200]}`,
                borderRadius: "8px",
                padding: "12px 14px",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                color: palette[700],
                fontSize: "12px",
            }}
        >
            <Typography sx={{ fontSize: "inherit", fontWeight: 700 }}>
                {isError
                    ? "We couldn’t save this configuration."
                    : "Saved with warnings."}
            </Typography>
            {messages.map((message, index) => (
                <Typography
                    key={index}
                    sx={{ fontSize: "inherit", overflowWrap: "anywhere" }}
                >
                    {message}
                </Typography>
            ))}
        </Box>
    );
};

export default EmissionsFormErrorBanner;
